// removed by extract-text-webpack-plugin
module.exports = {"home":"_2D5XHJOGbWrmU_zr1TTSI7","masthead":"_31t5ME8kXZNPifwSncDrGk","logo":"IwWtnsl8e4U1Wi9qgTpWj","humility":"_1giUysAvNGnNsD78SnksvM","github":"_3LsoPTipjA4Fit9F1Q2n05","counterContainer":"_3ujHSXGE-uCkm0anj0MtuT"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Language/Home.scss
// module id = 219
// module chunks = 0